<template> 
  <v-dialog v-model="dialogVisible" max-width="800px" max-height="500px" content-class="screenshot-carousel filter-group-container">
    <v-card >
      <v-card-text>
        <v-carousel 
          v-model="currentIndex" 
          hide-delimiters
          hide-delimiter-background
          hide-controls
          elevation="0"         
          class="no-border"
          :cycle="false"
        >
          <v-carousel-item v-for="(chunk, chunkIndex) in pagedImages" :key="chunkIndex">
            <v-container>
              <v-layout 
                row 
                wrap
              >
                <v-flex 
                  v-for="(imgItem, imgIndex) in chunk" 
                  :key="imgItem.id" 
                  xs3
                  class="screenshot-carousel--image"
                >
                  <screenshot-image-item
                    :key="imgItem.id"
                    :number ="allImages.length - allImages.findIndex(img => img.id === imgItem.id)"
                    :class="{ 'selected-print': imgItem.status === '1' } "
                    :item="imgItem"
                    :findingSelectItems="findingSelectItems"
                    :landmarkSelectItems="landmarkSelectItems"
                    @imgStatusChange="$emit('imgStatusChange', allImages.findIndex(img => img.id === imgItem.id))"
                    @findingChange="(v) => $emit('findingChange', {id: imgItem.id, newValue: v})"
                    @landmarkChange="(v) => $emit('landmarkChange', {id: imgItem.id, newValue: v})"
                    @setCurrentImage="()=> {
                      $emit('setCurrentImage', imgItem);
                    }"
                    @deleteImg="$emit('deleteImg', $event)"
                    hideLandmark
                    :allowEdit="true"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-carousel-item>
        </v-carousel>
      </v-card-text>
      <v-card-actions class="screenshot-carousel--action">
        <v-btn icon @click="prevPage" :disabled="currentIndex === 0">
          <v-icon color="black" class="prev-page">arrow_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn icon  @click="nextPage" :disabled="currentIndex === pagedImages.length - 1">
          <v-icon color="black" class="next-page">arrow_right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FindingMixin from '@/mixins/findingMixins'
import ScreenshotImageItem from '../../screenshots/ScreenshotImageItem.vue'
export default {
  mixins: [FindingMixin],
  components: { ScreenshotImageItem },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    allImages: {
      type: Array,
      required: true
    },
    filterItems: {
      type: Array,
      required: false
    },
    landmarks: {
      type: Array,
      required: true
    },
    voiceSelectionCommand: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    setVoiceSelectionCommand: {
      type: Function,
      required: false,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
    landmarkSelectItems() {
      let items = this.landmarks.map(elm => {
        return {
          value: elm.id,
          text: elm.landmark
        }
      })

      items.unshift({
        value: 0,
        text: this.$t('common.choose')
      })

      return items
    },
    filteredImages() {
      return this.allImages.filter(image => image.status !== 0 && image.status !== '0')
    },
    findingSelectItems() {
      let items = this.filterItems.map((elm, index) => {
        return {
          value: elm.id,
          text: `Finding ${index + 1}`
        }
      })

      items.unshift({
        value: 0,
        text: this.$t('common.choose')
      })

      return items
    },
    pagedImages() {
      const chunkSize = 8;
      const _tempList = this.filteredImages.reduce((acc, _, index) =>
      index % chunkSize === 0 ? [...acc, this.filteredImages.slice(index, index + chunkSize)] : acc, []);
      // console.log('_tempList', _tempList)
      return _tempList;
    }
  },
  data() {
    return {
      currentIndex: 0,
    };
  },
  methods: {
    openDialog(index) {
      this.currentIndex = index;
      this.dialogVisible = true;
    },
    prevPage() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    nextPage() {
      void 0
      if (this.currentIndex < this.pagedImages.length - 1) {
        void 0
        this.currentIndex++;
      }
    },
  },
  watch: {
    voiceSelectionCommand(val, oldVal) {
      if(!this.show || !val) return;
      void 0
      if (val.action === oldVal.action && val.target === oldVal.target) return
      switch (val.action) {
        case 'next page':
          this.nextPage();
          this.$emit('setVoiceSelectionCommand', {});
          break
        case 'previous page':
          this.prevPage();
          this.$emit('setVoiceSelectionCommand', {});
          break
        case 'off':
          this.dialogVisible = false;
          this.$emit('setVoiceSelectionCommand', {});
          break
        case 'delete':
          // const _img = this.allImages[this.allImages.length-val.target]
          const _img = this.allImages.find(img => img.imgSerial === parseInt(val.target))
          if(_img){
            this.$emit('deleteImg', _img.id)
          }
          break
      }
    }
  }
};
</script>
<style lang="scss">
@import '@/styles/components/filterImageGroup.scss';
.screenshot-carousel{
  border: 12px;
  &--action{
    position: absolute;
    top: 45%;
    width: 100%;
    padding-top: 0;
    background: transparent;
  }
  &--image{
    border-radius: 10px;
    padding: 10px;
  }
}
</style>
<style scoped>
.v-card-text {
  display: flex;
  justify-content: center;
  align-items: center;
}
.prev-page, .next-page{
  color: black !important;
}
.no-border{
  border: none !important;
  box-shadow: none !important;
}
.v-card{
  border-radius: 10px;
}
.gap{
  padding: 10px;
}
.v-card__text{
  max-height:460px;
  overflow: hidden;
}
</style>
